export const responseToString = (response, errorMessage) => {
    const { headers, ok, redirected, status, statusText, type, url, } = response;
    const responseJson = {
        headers,
        ok,
        redirected,
        status,
        statusText,
        type,
        url,
        errorMessage,
    };
    return ('ApiConnectionError.\n'
        + `response: ${JSON.stringify(responseJson)}\n`
        + `method: ${response.method}`);
};
const messageFromResponse = (errorText) => {
    if (errorText === '')
        return '';
    try {
        const parsedJson = JSON.parse(errorText);
        const message = parsedJson ? parsedJson.Message : '';
        // FIXME: Message is inconsistent on windows and linux server - unify
        return message.replace('\r', '');
    }
    catch (_a) {
        // NOTE: In some cases (such as error 502), response is not a JSON.
        return errorText;
    }
};
export const errorFromResponse = async (response) => {
    const errorText = await response.text();
    const message = messageFromResponse(errorText);
    return new ApiConnectionError(response, message);
};
export class ApiConnectionError extends Error {
    constructor(response, errorMessage = '') {
        super(responseToString(response, errorMessage));
        this.toString = () => (responseToString(this.response, this.errorMessage));
        // this is necesarry for instanceof to work:
        // https://www.typescriptlang.org/docs/handbook/2/classes.html#inheriting-built-in-types
        Object.setPrototypeOf(this, ApiConnectionError.prototype);
        this.response = response;
        this.errorMessage = errorMessage;
    }
}
